import React from 'react';
import { Form, RequiredHelpPhrase, Row, SubmitButton, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ListBoxModifier } from '../../../components/molecules/Form/components/ComboBox';

import { ContentSingleSelectComboBoxForForm2 } from '../../../components/molecules/Form/components/ComboBox/Content/ContentSingleSelectComboBox';
import { LatestForumPostsForm } from '../LatestForumPostsTypes';

type LatestForumPostsAddFormProps = {
  form: LatestForumPostsForm;
  refresh(): void;
};

export function LatestForumPostsAddForm({ form, refresh }: LatestForumPostsAddFormProps) {
  const { t } = useSonTranslation('LatestForumPosts');

  const { formProps, params, fetchState } = useForm({
    form,
    onSuccess: refresh,
  });

  const combobox = params.getByName('targetForumId');

  return (
    <Form id="latest-forum-posts-form" {...formProps}>
      <RequiredHelpPhrase />
      <Row>
        <ContentSingleSelectComboBoxForForm2
          suggestUrl={combobox.comboBoxUrl.url}
          hiddenInputName={combobox.name}
          required
          labelTitle={t('addForm.input.title')}
          modifierListBox={ListBoxModifier.RELATIVE}
          validationMessage={t('validationMessage')}
        />
      </Row>
      <SubmitButton
        buttonLabel={t('phrases:saveChanges')}
        messageSuccess={t('addForm.status.success')}
        messageSending={t('addForm.status.sending')}
        messageFail={t('addForm.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
